import { apiClient } from './api';

/**
 * 경영현황(대시보드)을 여는가 — 메뉴 · 관리자 첫 화면 · /work-sites 이동이 이 값 하나를 따른다.
 * 2026-10-30 운영에도 열었다. 다시 닫으려면 `window.location.hostname !== 'admin.grkcon.com'` 으로 되돌린다.
 */
export const MGMT_OPEN = true;

/**
 * 화면 금액 단위는 만원으로 통일한다(DB 는 그대로).
 * PPE(revenueItems.amount)는 만원 — 원으로 바꾸려면 × PPE_UNIT. OPEX · 법인카드 합계는 원 — 화면에서 ÷ PPE_UNIT.
 */
export const PPE_UNIT = 10000;
/** 원 → 만원 */
export const toMan = (won: number) => won / PPE_UNIT;

/** OPEX 확정 기준일 — 'last' 는 그 달 말일(임시값) */
export const OPEX_DUE: number | 'last' = 'last';

export interface DashboardData {
  year: number;
  month: number;
  today: string;
  tasks: {
    card: { year: number; month: number; confirmed: number; target: number; consolidated: boolean };
    insurance: { entered: boolean };
    payroll: { collected: boolean; transferFile: boolean };
    opex: { confirmed: boolean };
  };
  trend: { year: number; month: number; revenue: number; opex: number }[];
  business: {
    ongoing: number;
    planned: number;
    completedThisYear: number;
    revenueThisYear: number;
    endingThisMonth: number;
    nextEnding: { name: string; endDate: string } | null;
  };
  hr: { active: number; onLeaveToday: number; pendingLeave: number; annualUsedDays: number };
  card: { prevYear: number; prevMonth: number; prevTotal: number | null; confirmed: number; target: number };
}

export const dashboardApi = {
  get: (year: number, month: number) => apiClient.get<DashboardData>(`/dashboard?year=${year}&month=${month}`),
};
